export default "__VITE_ASSET__CMYZh8Tv__"